import { observable, action, decorate } from 'mobx';
import SimpleCaseStudyService from '../services/SimpleCaseStudy.service';

const DEFAULT_ARTICLES_LIMIT = 10;

class SimpleCaseStudyStore {
  searches = new Map();
  async fetchCaseStudies(criteria) {
    const { limit = DEFAULT_ARTICLES_LIMIT, page = 1, category } = criteria;

    const cacheKey = JSON.stringify({
      category,
      page,
      limit
    });

    const cachedSearch = this.searches.get(cacheKey);

    if (cachedSearch) {
      return cachedSearch;
    }
    try {
      const items = await SimpleCaseStudyService.fetchCaseStudies({
        limit,
        page,
        category
      });

      if (items.isEmpty) {
        return {
          isExploited: true,
          data: []
        };
      }

      const isNextPage = !!items.pagination.nextPage;

      const data = {
        isExploited: !isNextPage,
        data: items.items
      };

      this.searches.set(cacheKey, data);
      return data;
    } catch (e) {
      console.error('Failed to fetch featured case studies data', e);
      return null;
    }
  }
}

decorate(SimpleCaseStudyStore, {
  searches: observable,
  fetchArticles: action
});

export default new SimpleCaseStudyStore();



// WEBPACK FOOTER //
// ./src/stores/SimpleCaseStudy.store.js